import { createContext } from 'react';

export const BoundariesContext = createContext<Element | undefined>(undefined);
